import { action, makeObservable, runInAction } from "mobx";
import { API } from "General/API";
import { ObjectDataStore } from "Stores/RESTStoreInstances/ObjectDataStore";
import { userInfoStore } from "Stores";
import { handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";

class UserContactDataStore extends ObjectDataStore<API_UserContactData> {
  constructor() {
    super();
    makeObservable(this, {
      submit: action.bound,
    });

    this.data = {} as API_UserContactData;
  }
  url() {
    if (userInfoStore.loginInfo.unifiedAccount) {
      return API_URL.PAVE_USERS.getPAVEUserContactData(userInfoStore.id);
    } else {
      return API_URL.USERS.getUserContactData(userInfoStore.id);
    }
  }

  @handleStoreState()
  async submit(formData: API_UserContactData) {
    try {
      const data = { ...this.data, ...formData };
      await API.editData(this.url(), data);
      runInAction(() => {
        this.data = data;
      });
      userInfoStore.fetchStatus();
    } catch (err) {
      throw err;
    }
  }
  @handleStoreState()
  async confirmMaildAdress() {
    try {
      await API.editData(API_URL.USERS.confirmMailAddress(userInfoStore.id), { confirmMailAddress: true });
    } catch (err) {
      throw err;
    }
  }
}

const contactStore = new UserContactDataStore();

export { contactStore };
